module.exports = __webpack_public_path__ + "static/grundge_s-35e811b05978e2f79485468f36a59466.png";